export const TRANSLATION_TYPES = ['inline', 'image'] as const;

export type TranslationTypes = (typeof TRANSLATION_TYPES)[number];
